import { ImageURISource } from 'react-native'

export const isRemoteImageUrl = (uri?: string | null): uri is string => !!uri && /^https?:\/\//i.test(uri)

export const remoteImageSource = (uri?: string | null): ImageURISource | undefined => (isRemoteImageUrl(uri) ? { uri } : undefined)
